import { post } from '../../../data/shared/api_utils';
import URI from 'urijs';
import isArray from "lodash/isArray";

export const postQuotation = data => post('/api/reservation-request/submit', data);
export const postDraftQuote = data => post('/api/reservation-request/save-draft', data);

export const searchStops = (latA, lngA, latB, lngB, hikeId) => {
    const url = new URI(`/carto/${hikeId}/stops/search`);

    url.addSearch('latA', latA);
    url.addSearch('lngA', lngA);
    url.addSearch('latB', latB);
    url.addSearch('lngB', lngB);

    return fetch(url.toString());
}

export const planStepsForHike = (hikeId, distance) => {
    const url = new URI(`/carto/${hikeId}/steps/plan`);

    url.addSearch('distance', distance);

    return fetch(url.toString());
}

export const getSteps = (hikeId, fromStepId, direction = null) => {
    const url = new URI(`/carto/${hikeId}/steps`);

    if(fromStepId) {
        url.addSearch('fromStepId', fromStepId);
    }
    if(direction !== null){
        url.addSearch('direction', direction);
    }

    return fetch(url.toString());
}

export const getThemes = (locale = 'fr') => {
    const url = new URI('/carto/themes/'+locale);
    return fetch(url.toString());
}

export const getHikeBySlug = (slug, locale = 'fr') => {
    return fetch(`/carto/hikes/${locale}/${slug}`);
}
export const fetchMatchingBooking = (filters) => {
    const url = new URI(`/api/reservation-request/match`);

    Object.keys(filters).map(name => {
        if (null !== filters[name]) {
            url.addSearch(name, filters[name]);
        }
    });
    return fetch(url);
}
